import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Editor,toHTML } from 'ngx-editor';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-texts',
  templateUrl: './texts.component.html',
  styleUrls: ['styles.css'
  ]
})
export class TextsComponent implements OnInit {

  @ViewChild('info') info: ElementRef;

  public editor:Editor;
  public html;
  
  public texts={
    pf16Instructions:"",
    allPortInstructions:"",
    barsicInstructions:"",
    cleaverInstructions:"",
    ipvInstructions:"",
    kostikInstructions:"",
    termanInstructions:"",
    zavicInstructions:"",
    termanInstructions1:"",
    termanInstructions2:"",
    termanInstructions3:"",
    termanInstructions4:"",
    termanInstructions5:"",
    termanInstructions6:"",
    termanInstructions7:"",
    termanInstructions8:"",
    termanInstructions9:"",
    termanInstructions10:"",
    _id:"123456789987",
    info:""
  };
  constructor(private testService:TestService) {
    this.editor = new Editor();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        this.html = resp.info;

      },
      err=>console.log(err)
    )

  }

  update(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    this.texts.info = html;
    let obj = {
      _id: this.texts._id,
      info: html
    }
    this.testService.updateUseTexts(obj).subscribe(
      resp=>{
        Swal.fire('Actualizado');
      },
      err=>console.log(err)
    )
  }

}
